import { Component, OnInit, OnDestroy } from "@angular/core";
import { friendlyApiErrorMessage } from "src/app/services/api-error-notifier.service";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { TaskMgmtService } from "../../service/task-mgmt.service";
import { SessionService } from "src/app/services/session.service";
import { NavigationService } from "src/app/services/navigation.service";
import { DialogService } from "src/app/services/dialog.service";

@Component({
    selector: "app-task-detail-page",
    templateUrl: "./task-detail.component.html",
    styleUrls: ["./task-detail.component.scss"],
    standalone: false
})
export class TaskDetailPageComponent implements OnInit, OnDestroy {
  reqSubcription: Subscription[] = [];
  taskData: any = null;
  taskId: string = '';
  clientLogo: any;
  newColor: any;
  moduleName: string = '';
  isLoadingTask = true;
  loadError: string | null = null;
  private taskLoadSub: Subscription | null = null;

  constructor(
    private route: ActivatedRoute,
    private taskService: TaskMgmtService,
    private sessionService: SessionService,
    public navigationService: NavigationService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.clientLogo = this.sessionService.getClintLogo();
    this.newColor = this.sessionService.getColorCodes();

    const paramSub = this.route.params.subscribe(params => {
      this.taskId = params['taskId'];
      this.moduleName = decodeURIComponent(params['module'] || '');
      this.loadTask();
    });
    this.reqSubcription.push(paramSub);
  }

  ngOnDestroy(): void {
    this.taskLoadSub?.unsubscribe();
    this.reqSubcription.forEach(sub => sub.unsubscribe());
  }

  private loadTask(): void {
    this.isLoadingTask = true;
    this.loadError = null;
    // Cancel any previous getTaskById subscription — it never completes
    // (backed by a BehaviorSubject), so re-invocations on param change
    // would otherwise accumulate leaked subscriptions. (Fixes audit F2)
    this.taskLoadSub?.unsubscribe();
    this.taskLoadSub = this.taskService.getTaskById(this.taskId).subscribe({
      next: (task) => {
        this.isLoadingTask = false;
        if (task) {
          this.taskData = { ...task, taskStatus: true };
        } else {
          this.loadError = 'Case not found.';
        }
      },
      error: (err) => {
        this.isLoadingTask = false;
        this.loadError = friendlyApiErrorMessage(err, 'We couldn’t load this case. Please try again.');
      },
    });
  }

  onSaved(result: any): void {
    const sub = this.taskService
      .updateTask({ ...result, task_id: this.taskId })
      .subscribe({
        next: () => {
          this.dialogService.openSnackBar("Case updated successfully.", "OK");
          this.navigationService.goBack();
        },
        error: () => {
          this.dialogService.openSnackBar("Failed to save case.", "OK");
        },
      });
    this.reqSubcription.push(sub);
  }

  onCancelled(): void {
    this.navigationService.goBack();
  }
}
